import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tab-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tab-container" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tab-pane", [_ctx.tabPosition, _ctx.alignment]])
  }, [
    (_ctx.mode === 'router')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                custom: "",
                key: tab.path,
                to: tab.path
              }, {
                default: _withCtx(({ navigate, isActive }) => [
                  _createElementVNode("div", {
                    onClick: navigate,
                    class: _normalizeClass(["tab", { active: isActive }])
                  }, [
                    _renderSlot(_ctx.$slots, tab.slot, {}, () => [
                      (tab.icon)
                        ? (_openBlock(), _createBlock(_component_icon, {
                            key: 0,
                            name: tab.icon
                          }, null, 8, ["name"]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(tab.title), 1)
                    ])
                  ], 10, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-content", [_ctx.contentClass]])
          }, [
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component }) => [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ], 1024))
              ]),
              _: 1
            })
          ], 2)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["tab", { active: _ctx.activeTabName === tab.name }]),
                key: index,
                onClick: ($event: any) => (_ctx.onTabClick(tab))
              }, [
                _renderSlot(_ctx.$slots, tab.slot, {}, () => [
                  _createTextVNode(_toDisplayString(tab.title), 1)
                ])
              ], 10, _hoisted_4))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-content", [_ctx.contentClass]])
          }, [
            _renderSlot(_ctx.$slots, _ctx.activeTabName)
          ], 2)
        ], 64))
  ], 2))
}